import { apiFetch } from "@/lib/api";
import { Card, CardBody, CardHeader, CircularProgress } from "@heroui/react";
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";

interface Missoes {
  descricao: string;
  habilitado: boolean;
  id_missao: string;
  ordem: number;
  tag: string;
  titulo: string;
  xp_reward: number;
}

export default function Missoes() {
  const { data: session } = useSession();
  const [missoes, setMissoes] = useState<Missoes[]>([]);

  const fetchMissoes = async () => {
    const res = await apiFetch("/missoes", {
      headers: {
        Authorization: `Bearer ${session?.accessToken}`,
      },
    });

    const data = await res.json().catch(() => []);

    if (res.ok) {
      setMissoes(data);
    }
  };

  useEffect(() => {
    if (!session) return;
    fetchMissoes();
  }, [session]);

  return (
    <>
      {missoes.length > 0 ? (
        missoes.slice(0, 3).map((missao) => (
          <Card key={missao.id_missao} className="">
            <CardHeader className="text-md font-bold">{missao.titulo}</CardHeader>

            <CardBody className="flex items-end">
              <p className="font-light text-sm">{missao.descricao}</p>
              <span className="font-semibold text-green-500">+{missao.xp_reward} XP</span>
            </CardBody>
          </Card>
        ))
      ) : (
        <div className="w-full flex justify-center">
          <CircularProgress size="md" />
        </div>
      )}
    </>
  );
}
